module.exports = __webpack_public_path__ + "static/media/Sequoia.80959413.jpg";